export const formatRole = (role) =>
  role
    .replace("ROLE_", "")
    .toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
